import * as R from 'ramda';
import {generMutation, } from '@/utils';
import {getPathList, } from '@/utils/rbac';
import {USER_ROLE} from '@/config/enum';
import {getRbacList} from '@/config/rbac';

const state = {
  rbacList: [],
};

const actions = {
  getRbacList({commit, rootState}) {
    const {role} = rootState.common.userInfo;
    if (role === USER_ROLE.ADMIN) {
      commit('setRbacList', getRbacList([
        'AdminOrderCreate', 'AdminScorePoint',
        'Order', 'OrderAllInner', 'OrderUnsubmitInner', 'OrderProcessingInner',
        'OrderSubmitedInner', 'OrderFinishedInner', 'OrderUnsubmitDetail', 'OrderDetail', 'Account', 'Add', 'Department', 'Agent', 'DepartmentEdit', 'Hospital', 'AgentEdit',
        'DownloadLog', 'IPError', 'MultipleError', 'LogAudit', 'StlConfig', 'refund'
      ]));
    } else if (role === USER_ROLE.DOCTOR) {
      commit('setRbacList', getRbacList([
        'Order', 'OrderAll', 'OrderUnsubmit', 'OrderUnsubmitDetail',
        'OrderSubmited', 'OrderProcessing', 'OrderFinished', 'OrderCreate', 'OrderDetail'
      ]));
    } else if (role === USER_ROLE.CAPTAIN) {
      commit('setRbacList', getRbacList([
        'Order', 'OrderAll', 'OrderUnsubmit', 'OrderUnsubmitDetail', 'AdminOrderCreate',
        'OrderSubmited', 'OrderProcessing', 'OrderFinished', 'OrderDetail',
        'Account', 'AdminScorePoint'
      ]));
    } else if (role === USER_ROLE.WORKER) {
      commit('setRbacList', getRbacList([
        'Order', 'OrderAll',
        'OrderSubmited', 'OrderProcessing', 'OrderFinished', 'OrderDetail',
        'Account', 'WorkerScorePoint'
      ]));
    } else if (role === USER_ROLE.AGENT) {
      commit('setRbacList', getRbacList([
        'AgentOrderCreate', 'Order', 'OrderAll', 'OrderUnsubmit', 'OrderUnsubmitDetail', 'DepartmentEdit',
        'OrderSubmited', 'OrderProcessing', 'OrderFinished', 'OrderDetail', 'AgentHospitalManage', 'AgentDepartmentManage', 'AgentAccountAdd', 'Department', 'FinanceManage', 'AgentMoneyDetail'
      ]));
    } else {
      commit('setRbacList', getRbacList([
        'Order', 'OrderAll', 'OrderUnsubmit', 'OrderUnsubmitDetail',
        'OrderSubmited', 'OrderProcessing', 'OrderFinished', 'OrderDetail'
      ]));
    }
  },
};

const getters = {
  flattenRbacList(state) {
    return getPathList(state.rbacList);
  },
  navList(state) {
    function computedNavList(navList) {
      const resultList = [];
      R.forEach((item) => {
        const {path, name, showType = 'NAV', children, icon, activeIcon} = item;
        const type = showType.toUpperCase();
        if (type === 'API') { // 过滤api类型权限
          return;
        }
        const data = {path, name};
        if (icon && activeIcon) {
          data.icon = icon;
          data.activeIcon = activeIcon;
        }
        if (type === 'NAV' && R.type(children) === 'Array' && children.length > 0) {
          data.children = computedNavList(children); // 递归
        } else {
          data.children = [];
        }
        // 是导航类型并且没有子项的时候，不显示此项
        if (type === 'NAV' && R.type(children) === 'Array' && children.length === 0) return;
        resultList.push(data);
      }, navList);
      return resultList;
    }

    return computedNavList(state.rbacList);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations: generMutation(R.keys(state)),
};



// WEBPACK FOOTER //
// ./src/store/rbac/index.js